import { UntypedFormGroup } from "@angular/forms";

export function EndDateInFuture(endDateControlName: string) {
    return (formGroup: UntypedFormGroup) => {
        const endDateControl = formGroup.controls[endDateControlName];

        if(endDateControl.errors && !endDateControl.errors.endDateBeforeStartDate){
           // return if another validator has already found an error on the endDateControl
           return; 
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        let startDate = new Date(today.getDate() + 1);
        let endDate = new Date(endDateControl.value);

        if(endDate < startDate){
            if(endDateControl.touched){
                endDateControl.setErrors({endDateInFuture: true});
            }
        }
    }    
}